export enum NotificationsTypes {
  SUCCESS = 'success',
  ERROR = 'error'
}
